<script setup>
import TextInput from '@/Components/Input/TextInput.vue';
import { Netmask } from 'netmask';
import { reactive } from 'vue';
import PrimaryButton from '@/Components/Button/PrimaryButton.vue';
import Card from '@/Components/Card/Card.vue';
import { useI18n } from 'vue-i18n';
import { TOOL_CIDR_CALCULATOR, captureToolUsed } from '@/Common/Posthog.js';

const { t } = useI18n();

const state = reactive({
  cidr: '',
  result: null
});

const submit = () => {
  const block = new Netmask(state.cidr);

  state.result = {
    cidr_range: state.cidr,
    cidr_base: block.base,
    netmask: block.mask,
    bitmask: block.bitmask,
    host: block.hostmask,
    broadcast: block.broadcast,
    block_size: block.size,
    first_ip: block.first,
    last_ip: block.last
  };

  captureToolUsed({
    tool: TOOL_CIDR_CALCULATOR,
    properties: { mode: 'cidr_to_range' }
  });
};
</script>

<template>
  <form
    class="flex grow flex-col gap-4 md:flex-row md:items-center"
    @submit.prevent="submit"
  >
    <TextInput
      v-model.trim="state.cidr"
      size="large"
      description="e.g. 127.0.0.1/15"
      label="CIDR"
      :placeholder="$t('cidr_calculator.partials.cidr_to_ip_form.enter_cidr')"
      @input="state.result = null"
    />
    <div class="flex items-center md:mt-2">
      <PrimaryButton size="large" @click="submit">
        {{ $t('cidr_calculator.partials.cidr_to_ip_form.calculate') }}
      </PrimaryButton>
    </div>
  </form>

  <Teleport v-if="state.valid !== null" to="#results">
    <Card>
      <div class="flex flex-col gap-4">
        <div
          v-for="(value, key) in state.result"
          :key="key"
          class="flex items-end justify-between md:justify-start"
        >
          <div class="w-3/12 font-bold">
            {{ t(`cidr_calculator.partials.cidr_to_ip_form.${key}`) }}
          </div>
          <div>
            {{ value }}
          </div>
        </div>
      </div>
    </Card>
  </Teleport>
</template>
